import {
    Box, Flex
} from '@chakra-ui/react';
import React, { ReactElement } from 'react';

import * as styled from './user-menu-item-button.styled';

type UserMenuItemButtonProps = {
    leftIcon?: React.ReactNode
    rightIcon?: React.ReactNode
    title: string | ReactElement
    url?: string
    onClick: () => void
};

export const UserMenuItemButton = ({
    leftIcon = null,
    rightIcon = null,
    title,
    onClick
}: UserMenuItemButtonProps) => {
    return (
        <styled.container onClick={onClick}>
            <Flex alignItems={'center'}>
                <Box mr={'12px'}>{leftIcon}</Box>
                {title}
            </Flex>
            <Box>{rightIcon}</Box>
        </styled.container>
    );
};
